module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "org-detail"
  }, [(_vm.status == 0) ? _c('Entdetail', {
    attrs: {
      "dataEnt": _vm.dataEnt
    }
  }) : _vm._e(), _vm._v(" "), (_vm.status == 2) ? _c('Parkdetail', {
    attrs: {
      "dataPark": _vm.dataPark
    }
  }) : _vm._e(), _vm._v(" "), (_vm.status == 3) ? _c('Wtdetail', {
    attrs: {
      "dataWt": _vm.dataWt
    }
  }) : _vm._e(), _vm._v(" "), (_vm.status == 1) ? _c('Govdetail', {
    attrs: {
      "dataGov": _vm.dataGov
    }
  }) : _vm._e(), _vm._v(" "), (_vm.status == 4) ? _c('Otherdetail', {
    attrs: {
      "dataOther": _vm.dataOther
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "org-control"
  }, [_c('el-button', {
    staticStyle: {
      "width": "100px",
      "margin-top": "20px"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("修改")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40f0c14d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/unit/informa.vue
// module id = 1217
// module chunks = 2